import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "priceshow__container" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "priceshow__results" }
const _hoisted_4 = { class: "row g-0" }
const _hoisted_5 = { class: "col-12 col-search" }
const _hoisted_6 = { class: "col-search__sticky" }
const _hoisted_7 = { class: "priceshow__content" }
const _hoisted_8 = {
  key: 0,
  class: "priceshow__content_slider"
}
const _hoisted_9 = {
  key: 1,
  class: "col-12 fs-regular noProducts"
}
const _hoisted_10 = { class: "row g-0" }
const _hoisted_11 = { class: "col-12 priceshow-contact-widget" }
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]

import {
  reactive,
  onMounted,
  computed,
  watch,
  ref,
  onBeforeUnmount, nextTick,
} from 'vue';
import {
  useStore,
} from 'vuex';
import {
  LocationQueryValue,
  useRoute,
  useRouter,
} from 'vue-router';
import BaseEqualizer from '@/components/BaseEqualizer.vue';
import PriceshowContactWidget from '@/components/PriceshowPage/PriceshowContactWidget.vue';
import ProductCard from '@/components/product/PriceCard.vue';
import { Product } from '@/classes';
import { DataLayer } from '@/classes/DataLayer';
import PriceSearchCard from '@/components/PriceSearchCard.vue';
import { env } from '@/helpers';
import ExitPopup from '@/components/ExitPopup.vue';
import CardSlider from '@/components/CardSlider.vue';
import BaseEqualizerElement from '@/components/BaseEqualizerElement.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceshowPage',
  setup(__props) {

const route = useRoute();
const store = useStore();
const router = useRouter();
const stickyCont = ref();
const priceshowEqualizer = ref<InstanceType<typeof BaseEqualizer>>();

const routeQueryVars = computed(() => route.query);
const routeParamVars = computed(() => route.params);

const isFetching = computed(() => store.getters['priceshow/loading']);
const products = computed(() => store.getters['priceshow/productsFiltered']);

const exitPopupHeadline = env('EXIT_POPUP_HEADLINE', '');
const exitPopupText = env('EXIT_POPUP_TEXT', '');
const exitPopupUrlText = env('EXIT_POPUP_LINKTEXT', '');
const getExitPopupUrl = routeQueryVars.value?.epu;
const exitPopupUrl = `${env('CORPORATE_URL')}/${getExitPopupUrl}`;

const cartItemKey = ref(routeQueryVars.value.cik);

const priceshow = reactive({
  params: {
    double: routeParamVars.value.usageHt ? 1 : 0,
    usage: parseInt(`${routeParamVars.value.usage}`, 10),
    usageHt: parseInt(`${routeParamVars.value.usageHt || 0}`, 10),
    postcode: routeParamVars.value.postcode,
    city: routeQueryVars.value.stadt,
    street: routeQueryVars.value.strasse,
    houseNumber: routeQueryVars.value.hausnummer,
    branch: routeParamVars.value.branch,
    business: parseInt(`${routeQueryVars.value?.gewerbe || 0}`, 10),
    affiliateId: routeQueryVars.value?.aid,
    lz: routeQueryVars.value?.lz,
    pg: routeQueryVars.value?.pg,
    exitPopupLink: routeQueryVars.value?.epu,
    subCategories: routeQueryVars.value.subCategories,
    typeOfMeasurement: routeQueryVars.value.typeOfMeasurement,
    pid: routeQueryVars.value?.pid,
  },
});

const productsSorted = ref<Product[]>([]);

let dataLayerUsage: number;
if (priceshow.params.usageHt) {
  dataLayerUsage = priceshow.params.usageHt + priceshow.params.usage;
} else {
  dataLayerUsage = priceshow.params.usage;
}

const pushAvailableProductsToLayer = () => {
  DataLayer.push({ event: null });
  if (products.value.length <= 0) {
    DataLayer.push({
      event: 'no_tariff_available',
      customer_type: priceshow.params.business ? 'company' : 'private',
      postcode: priceshow.params.postcode,
      consumption: dataLayerUsage,
      energy_type: priceshow.params.branch,
    });
  } else {
    DataLayer.push({
      event: 'available_tariffs',
      customer_type: priceshow.params.business ? 'company' : 'private',
      postcode: priceshow.params.postcode,
      consumption: dataLayerUsage,
      offers: productsSorted.value.map((product: Product) => product.attributes.name),
      energy_type: priceshow.params.branch,
    });
  }
};

const pushCalculateToLayer = () => {
  DataLayer.push({ event: null });
  if (products.value.length <= 0) {
    DataLayer.push({
      event: 'calculate_error',
      customer_type: priceshow.params.business ? 'company' : 'private',
      message: 'Leider konnten für Deine Angaben aktuell keine Preise ermittelt werden.',
      postcode: priceshow.params.postcode,
      consumption: dataLayerUsage,
      energy_type: priceshow.params.branch,
    });
  } else {
    DataLayer.push({
      event: 'calculate',
      customer_type: priceshow.params.business ? 'company' : 'private',
      postcode: priceshow.params.postcode,
      consumption: dataLayerUsage,
      energy_type: priceshow.params.branch,
    });
  }
};

watch(() => products.value, () => {
  productsSorted.value = [...products.value].sort(($pa, $pb) => {
    if ($pa.attributes.position !== null && $pb.attributes.position !== null) {
      return $pa.attributes.position - $pb.attributes.position;
    } if ($pa.attributes.position !== null && $pb.attributes.position === null) {
      return -1;
    } if ($pa.attributes.position === null && $pb.attributes.position !== null) {
      return 1;
    }

    if ($pa.isRecommended !== $pb.isRecommended) {
      return $pa.isRecommended ? -1 : 1;
    }

    if (routeQueryVars.value.gewerbe === '1') {
      if ($pa.attributes.details.customerType === 'business' && $pb.attributes.details.customerType !== 'business') {
        return -1;
      }
      if ($pa.attributes.details.customerType !== 'business' && $pb.attributes.details.customerType === 'business') {
        return 1;
      }

      const termOrder: Record<string, number> = {
        12: 1,
        24: 2,
        1: 3,
      };

      const termComparison = termOrder[$pa.attributes.details.contractDetails.contract_term_months] - termOrder[$pb.attributes.details.contractDetails.contract_term_months];

      if (termComparison !== 0) {
        return termComparison;
      }
    }

    return $pa.attributes.details.contractDetails.contract_term_months > $pb.attributes.details.contractDetails.contract_term_months ? 1 : -1;
  });

  const getFilterValue = (value: any): string => (Array.isArray(value) ? value.join(',') : value ?? '');

  const filterLz = getFilterValue(routeQueryVars.value.lz);
  const filterPG = getFilterValue(routeQueryVars.value.pg);
  const filterPid = getFilterValue(routeQueryVars.value.pid);

  const filterProductsByTerms = (productsFilter: any[], terms: string[], field: string) => productsFilter.filter((p) => terms.includes(String(p[field])));

  const filterProductsByPriceGuarantee = (productsFilter: any[], terms: string[]) => {
    const pgTerms = terms.filter((term) => term !== '0');

    return productsFilter.filter((p) => (terms.includes('0') && p.priceGuaranteeTermMoths === null && !p.priceGuaranteeIsFixed)
        || pgTerms.includes(String(p.priceGuaranteeTermMoths)));
  };

  const filterProductsBySubCategory = (productsFilter: any[], subCategory: string | LocationQueryValue[]) => productsFilter.filter((p) => p.attributes.details.categories.some((category) => category.key === subCategory));

  const filterProductsByTypeOfMeasurement = (productsFilter: any[], typeOfMeasurement: string | LocationQueryValue[]) => productsFilter.filter((p) => (typeOfMeasurement === 'doubleTariffWithHouseholdPower' && p.attributes.details.contractDetails.doubleTariffWithHouseholdPower)
      || (typeOfMeasurement === 'doubleTariffWithoutHouseholdPower' && p.attributes.details.contractDetails.doubleTariffWithoutHouseholdPower));

  if (priceshow.params.lz) {
    productsSorted.value = filterProductsByTerms(productsSorted.value, filterLz.split(','), 'contractTermMonths');
  }

  if (priceshow.params.pg) {
    productsSorted.value = filterProductsByPriceGuarantee(productsSorted.value, filterPG.split(','));
  }

  if (filterPid) {
    productsSorted.value = [...products.value].filter(($pa) => filterPid.split(',').map(Number).includes($pa.attributes.id));
  }

  if (priceshow.params.subCategories) {
    productsSorted.value = filterProductsBySubCategory(productsSorted.value, priceshow.params.subCategories);
  }

  if (priceshow.params.typeOfMeasurement === 'doubleTariffWithoutHouseholdPower' || priceshow.params.typeOfMeasurement === 'doubleTariffWithHouseholdPower') {
    productsSorted.value = filterProductsByTypeOfMeasurement(productsSorted.value, priceshow.params.typeOfMeasurement);
  }

  pushCalculateToLayer();
  pushAvailableProductsToLayer();

  nextTick(() => {
    if (priceshowEqualizer.value) {
      priceshowEqualizer.value.runEqualize();
    }
  });
});

const fetchPrices = () => {
  store.dispatch('priceshow/fetch', priceshow.params);
};

const setPriceshowParams = () => {
  priceshow.params.city = routeQueryVars.value.stadt;
  priceshow.params.street = routeQueryVars.value.strasse;
  priceshow.params.houseNumber = routeQueryVars.value.hausnummer;
  priceshow.params.branch = routeParamVars.value.branch;
  priceshow.params.postcode = routeParamVars.value.postcode;
  priceshow.params.double = routeParamVars.value.usageHt ? 1 : 0;
  priceshow.params.usage = parseInt(`${routeParamVars.value.usage}`, 10);
  priceshow.params.usageHt = parseInt(`${routeParamVars.value.usageHt || 0}`, 10);
  priceshow.params.subCategories = routeQueryVars.value.subCategories;
  priceshow.params.typeOfMeasurement = routeQueryVars.value.typeOfMeasurement;
  priceshow.params.lz = routeQueryVars.value.lz;
  priceshow.params.pg = routeQueryVars.value.pg;
  priceshow.params.pid = routeQueryVars.value.pid;
  priceshow.params.affiliateId = routeQueryVars.value.aid;
};

const showOtherBranchModalProduct = ref<Product | null>(null);

watch(() => ({
  ...routeParamVars.value,
  ...routeQueryVars.value,
}), () => {
  showOtherBranchModalProduct.value = null;
  setPriceshowParams();
  fetchPrices();
}, { deep: true });

onMounted(() => {
  fetchPrices();
});

const clickOrder = ($product: Product) => {
  store.commit('priceshow/SET_LOADING', true);
  store.commit('exitPopup/SET_URL', priceshow.params.exitPopupLink);

  store.dispatch('cart/add', {
    product: $product,
    cartItemKey: cartItemKey.value,
    params: priceshow.params,
    entry: true,
  }).then((response) => {
    if (response.cartEnabled) {
      router.push('/warenkorb/');
    } else {
      router.push('/bestellung/adresse/');
    }
  });
};

const setStickyTop = () => {
  const header = document.querySelector('header');
  if (stickyCont.value && header) {
    stickyCont.value.style.top = `${header.offsetHeight}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  setStickyTop();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setStickyTop);
  window.removeEventListener('load', setStickyTop);
});

return (_ctx: any,_cache: any) => {
  const _component_BasePageHeader = _resolveComponent("BasePageHeader")!
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isFetching.value)
      ? (_openBlock(), _createElementBlock("section", {
          class: "priceshow",
          key: `priceshow-${productsSorted.value.length}`
        }, [
          _createVNode(_component_BasePageHeader, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Wähle deinen Wunschtarif ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      ref_key: "stickyCont",
                      ref: stickyCont
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(PriceSearchCard, {
                          options: priceshow.params,
                          "preselected-options": priceshow.params
                        }, null, 8, ["options", "preselected-options"])
                      ])
                    ], 512)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (productsSorted.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(), _createBlock(BaseEqualizer, {
                          ref_key: "priceshowEqualizer",
                          ref: priceshowEqualizer,
                          key: `equalizer-${productsSorted.value.map(product => product.id).join('-')}`
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(CardSlider, {
                              key: `slider-${productsSorted.value.map(product => product.id).join('-')}`
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsSorted.value, (product) => {
                                  return (_openBlock(), _createBlock(BaseEqualizerElement, {
                                    class: "col-12 col-xxl-6 col-xxxl-4",
                                    key: `product-${product.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(ProductCard, {
                                        key: `fetch-product-${product.id}`,
                                        "is-single": productsSorted.value.length === 1,
                                        product: product,
                                        position: _ctx.inx + 1,
                                        recommended: product.isRecommended,
                                        onCart: clickOrder
                                      }, null, 8, ["is-single", "product", "position", "recommended"]))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          ]),
                          _: 1
                        }))
                      ]))
                    : _createCommentVNode("", true),
                  (productsSorted.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Leider konnten für Deine Angaben aktuell keine Preise ermittelt werden. "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(PriceshowContactWidget)
                  ])
                ])
              ])
            ])
          ]),
          (_unref(getExitPopupUrl))
            ? (_openBlock(), _createBlock(ExitPopup, {
                key: 0,
                headline: _unref(exitPopupHeadline),
                class: "newsletter-exit-popup",
                once: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (_unref(exitPopupText))
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          innerHTML: _unref(exitPopupText)
                        }, null, 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      class: "base-button btn btn-primary text-center fs-regular",
                      href: exitPopupUrl,
                      target: "_blank",
                      innerHTML: _unref(exitPopupUrlText)
                    }, null, 8, _hoisted_14)
                  ])
                ]),
                _: 1
              }, 8, ["headline"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isFetching.value)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})